import $ from 'jquery';
import _ from 'ext:lodash';
import Framework from 'framework';
import ProfileStore from 'framework/stores/ProfileStore';
import constants from 'lib/constants';
import profileStoreIsAvailable from 'lib/profile-store-utils';
import authUtils from "lib/auth-utils";

$(() => {
	const biosSpringApiFlagEnabled = authUtils.isFeatureFlagEnabled(constants.biosSpringApiFlag);
            
    //show hidden content to authenticated/remembered users (if profile store is available)
    if (profileStoreIsAvailable) {
        let profile = ProfileStore.getInitialData();
        if (!(profile.memberState === constants.memberState.unknown)) {
            if (profile.memberState === constants.memberState.authenticated || profile.memberState === constants.memberState.remembered) {
                $('#bioSocial').removeClass('hidden-xs-up');
            }
        } else {
            ProfileStore.listen((profileData) => {
                if (profileData.memberState === constants.memberState.authenticated || profileData.memberState === constants.memberState.remembered) {
                    $('#bioSocial').removeClass('hidden-xs-up');
                }
            });
        }
    }

	// validate and submit testimonials
	var parsleyConfig = {
		trigger: 'change',
		errorClass: 'has-danger',
		classHandler: function (el) {
			return el.$element.closest('.form-group'); //working
		},
		errorsWrapper: '<ul class="label-help"></ul>'
	};
	var contactForm = $('#biosContactForm');
	if(contactForm.length){
		contactForm.parsley(parsleyConfig);
		$('#submitContact').on('click', function (event) {
			contactForm.parsley().validate();
			if(contactForm.parsley().isValid()){
				var profilePath = contactForm.find('input#profilePathContact').val();
				var contactUrl;
				if(biosSpringApiFlagEnabled) {
					contactUrl = Framework.global.lt.api.ltApiUrl + '/aem/bios/v1/bios/profile/'+profilePath+'/contact';
				} else {
					contactUrl = Framework.global.lt.api.apimUrl + 'ux/biosadmin/v1/bios/profile/'+profilePath+'/contact';
					//var contactUrl = 'http://localhost:8115/proc/biosadmin/v1/bios/profile/'+profilePath+'/contact';
				}
				var reqData = new Object();
				reqData.firstName = contactForm.find('input#firstName').val();
				reqData.lastName = contactForm.find('input#lastName').val();
				reqData.message = contactForm.find('textarea#message').val();
				reqData.phone = contactForm.find('input#phone').val();
				reqData.email = contactForm.find('input#email').val();
				var contactStr = '';
				if(contactForm.find('input#cMorning').is(':checked')){
					contactStr += 'Morning';
				}
				if(contactForm.find('input#cAfternoon').is(':checked')){
					if(contactStr.length>0){
						contactStr +=', ';
					}
					contactStr += 'Afternoon';
				}
				if(contactForm.find('input#cEvening').is(':checked')){
					if(contactStr.length>0){
						contactStr +=', ';
					}
					contactStr += 'Evening';
				}
				reqData.time=contactStr;
				$.ajax({
					url: contactUrl,
					method: 'POST',
					beforeSend: function(request) {
						if(biosSpringApiFlagEnabled) {
							request.setRequestHeader('apikey', Framework.global.lt.api.biosApiKey);
						} else {
							request.setRequestHeader('ocp-apim-subscription-key', Framework.global.lt.api.commprefsKey);
						}
					  },
					data: JSON.stringify(reqData),
					contentType: 'application/json; charset=utf-8',
					success: function (result) {
						$('#bioContactForm').modal('hide');
						Framework.actions.createSuccessNotification('<strong>Thank you for getting in touch!</strong><br>We received your message, have a great day.');
					},
					error: function (result) {
						$('#bioContactForm').modal('hide');
						Framework.actions.createDangerNotification('We were unable to accept your message at this time, please try again later.');
					}
				});
			}
		});
	}
	var testimonialForm = $('#biosTestimonialForm');
	if(testimonialForm.length){
		testimonialForm.parsley(parsleyConfig);
		$('#submitTestimonial').on('click', function (event) {
			testimonialForm.parsley().validate();
			if(testimonialForm.parsley().isValid()) {
				var modal = $('#bioTestimonial');
				var profilePath = testimonialForm.find('input#profilePath').val();
				var testimonialUrl;
				if(biosSpringApiFlagEnabled) {
					testimonialUrl= Framework.global.lt.api.ltApiUrl + '/aem/bios/v1/bios/profile/'+profilePath+'/testimonial';
				} else {
					testimonialUrl= Framework.global.lt.api.apimUrl + 'ux/biosadmin/v1/bios/profile/'+profilePath+'/testimonial';
					//var testimonialUrl = 'http://localhost:8115/proc/biosadmin/v1/bios/profile/'+profilePath+'/testimonial';
				}
				var reqData = new Object();
				reqData.firstName = testimonialForm.find('input#firstNameTest').val();
				reqData.lastName = testimonialForm.find('input#lastNameTest').val();
				reqData.testimonial = testimonialForm.find('textarea#testComments').val();
				reqData.acceptTerms = testimonialForm.find('input#agreeTerms').is(':checked');
				$.ajax({
					url: testimonialUrl,
					method: 'POST',
					beforeSend: function(request) {
						if(biosSpringApiFlagEnabled) {
							request.setRequestHeader('apikey', Framework.global.lt.api.biosApiKey);
						} else {
							request.setRequestHeader('ocp-apim-subscription-key', Framework.global.lt.api.commprefsKey);
						}
					  },
					data: JSON.stringify(reqData),
					contentType: 'application/json; charset=utf-8',
					success: function (result) {
					    modal.modal('hide');
					    modal.on('hidden.bs.modal', function(){
							Framework.actions.createSuccessNotification('<strong>Thank you for getting in touch!</strong><br>We received your testimonial, have a great day.');
							modal.off('hidden.bs.modal');
						});
					},
					error: function (result) {
						modal.modal('hide');
					    modal.on('hidden.bs.modal', function(){
							Framework.actions.createDangerNotification('We were unable to accept your testimonial at this time, please try again later.');
							modal.off('hidden.bs.modal');
						});
					}
				});
			}
		});
	}

	// add Spotify to page when available
	var spotifyPlayer = $('#biosSpotifyPlayer');
	if(spotifyPlayer.length){
		var playlistPath = spotifyPlayer.data('playlistPath');
		var pattern = 'playlist/';
		var playlistId = playlistPath.substr(playlistPath.indexOf(pattern)+pattern.length, playlistPath.length);
		//remove extra url parameters, if any
		if (playlistId.indexOf('?') >= 0) {
			playlistId = playlistId.substr(0, playlistId.indexOf('?'));
		}
		$.get( '/bin/lt/trainerPlaylist.json?playlistId=' + playlistId, (data)=> {
			if(data) {
				var playlist = data;
				var playerTemplate = `
					<div class="b-t p-y-2">
						<div class="bio-playlist b-a">
							<div class="bio-playlist-header b-b">
								<div class="bio-playlist-btn pull-xs-left m-r-1">
									<img src="${playlist.images[0].url}" alt="" />
									<a href="${playlist.external_urls.spotify}" class="btn btn-video btn-xs" target="_blank">
										<span class="sr-only">Play playlist in new window</span>
									</a>
								</div>
								<div class="bio-playlist-text">
									<p class="text-truncate font-weight-bold text-gray-3 m-b-0">${playlist.name}</p>
									<p class="text-truncate text-muted small m-b-0">${playlist.owner.display_name}</p>
								</div>
								<div class="bio-playlist-logo">
									<a href="${playlist.external_urls.spotify}" target="_blank">
										<svg role="img" aria-labelledby="spotifyTitle" xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 32 32"><title id="spotifyTitle">Listen on Spotify</title><path fill="#1ED760" d="M16,0C7.2,0,0,7.2,0,16c0,8.8,7.2,16,16,16c8.8,0,16-7.2,16-16C32,7.2,24.8,0,16,0z M23.3,23.1 c-0.3,0.5-0.9,0.6-1.4,0.3c-3.8-2.3-8.5-2.8-14.1-1.5c-0.5,0.1-1.1-0.2-1.2-0.7c-0.1-0.5,0.2-1.1,0.8-1.2 c6.1-1.4,11.3-0.8,15.5,1.8C23.5,22,23.6,22.6,23.3,23.1z M25.3,18.7c-0.4,0.6-1.1,0.8-1.7,0.4c-4.3-2.6-10.9-3.4-15.9-1.9 c-0.7,0.2-1.4-0.2-1.6-0.8c-0.2-0.7,0.2-1.4,0.8-1.6c5.8-1.8,13-0.9,18,2.1C25.5,17.4,25.7,18.1,25.3,18.7z M25.5,14.2 c-5.2-3.1-13.7-3.3-18.6-1.9c-0.8,0.2-1.6-0.2-1.9-1c-0.2-0.8,0.2-1.6,1-1.9c5.7-1.7,15-1.4,21,2.1c0.7,0.4,0.9,1.3,0.5,2.1 C27.1,14.4,26.2,14.6,25.5,14.2z"/></svg>
									</a>
								</div>
							</div>
							<div class="bio-tracks">
								<ol class="list-unstyled m-b-0">
									${playlist.tracks.items.map((item) =>
										`<li>
											<a href="${item.track.external_urls.spotify}" target="_blank" class="bio-track">
												<div class="bio-track-text">
													<p class="text-truncate text-gray-4 m-b-0">${item.track.name}</p>
													<p class="text-truncate text-muted micro m-b-0">
														${item.track.artists.map((artist) => `${artist.name}`).join(', ')}
													</p>
												</div>
												<div class="bio-track-dur">
													${Math.floor(item.track.duration_ms / 60000) + ":" + (((item.track.duration_ms % 60000) / 1000).toFixed(0) < 10 ? '0' : '') + ((item.track.duration_ms % 60000) / 1000).toFixed(0)}
												</div>
											</a>
										</li>`
									).join('')}
								</ol>
							</div>
						</div>
					</div>
				`;
				$(spotifyPlayer).append(playerTemplate);
				$('#bioPlaylist').removeClass('hidden-xs-up');
			}
		});
	}
});
